<template>
  <div style="background-color: white">
    <el-row style="padding-top: 10px">
      <el-col :span="24">
        <el-button
          size="small"
          class="btn"
          type="primary"
          v-if="show.lr"
          @click="handleCreate"
          >录入</el-button
        >
        <el-button size="small" type="primary" class="btn" @click="derive">导出列表</el-button>
        <el-button
          size="small"
          type="primary"
          class="btn"
          v-if="show.dcfj"
          @click="dcfj"
          >导出核查附件</el-button
        >
        <el-form
          :inline="true"
          ref="deviceInfo"
          :model="deviceInfo"
          class="demo-form-inline"
          style="float: right !important"
        >
        <el-form-item label="筛选单位">
            <el-cascader
            v-model="deviceInfo.companyCode" 
              :options="companyTree"
              :show-all-levels="false"
              :props="props"
              clearable
            ></el-cascader>
          </el-form-item>
          <el-form-item :label="lable.checkTime">
            <el-date-picker
              v-model="deviceInfo.date"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              value-format="yyyy-MM-dd"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-input
              v-model="deviceInfo.content"
              auto-complete="off"
              placeholder="请输入搜索内容"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" @click="findAllClick"
              >查询</el-button
            >
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table
          :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }"
          :cell-style="{ textAlign: 'center' }"
          ref="multipleTable"
          :data="checkData"
          :row-key="getRowKeys"
          @selection-change="changeCheckBoxValue"
          tooltip-effect="dark"
          style="width: 100%; text-align: center"
          stripe
        >
          <el-table-column type="selection" width="55"   :reserve-selection="true"> </el-table-column>
          <el-table-column
            :label="lable.index"
            type="index"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span>{{ scope.$index + (pageIndex - 1) * pagesize + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="id"
            sortable
            :label="lable.id"
            show-overflow-tooltip
          >
            <template slot-scope="scope" show-overflow-tooltip>
              <el-link
                :underline="false"
                @click="details(scope.row)"
                style="color: #4095e5; text-decoration: none"
              >
                {{ scope.row.id }}
              </el-link>
            </template>
          </el-table-column>
          <el-table-column
            prop="glbh"
            sortable
            :label="lable.glbh"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="jdsb"
            sortable
            :label="lable.jdsb"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="ssdw"
            sortable
            :label="lable.companyName"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            sortable
            prop="checkTime"
            :label="lable.checkTime"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="jg"
            sortable
            :label="lable.jg"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="nextCheckTime"
            sortable
            :label="lable.nextCheckTime"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="checkStatue"
            sortable
            :label="lable.statue"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span v-if="scope.row.checkStatue == 1" style="color: #4095e5"
                >待确认</span
              >
              <span v-else style="color: blueviolet">核查完成</span>
            </template>
          </el-table-column>
          <el-table-column :label="lable.cz" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-button
                type="text"
                v-if="scope.row.checkStatue == 0 && show.zf"
                @click="deleteCheck(scope.row)"
                >删除</el-button
              >

              <el-button @click="details(scope.row)" type="text"
                >详情</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <!--分页工具条-->
      <el-col :span="24" class="toolbar" style="margin-top: 5px; height: 35px">
        <el-pagination
          v-if="checkData.length > 0"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pagesize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          style="float: right"
        >
        </el-pagination>
      </el-col>
    </el-row>
    <div
      style="
        position: fixed;
        top: 13%;
        left: 42%;
        height: 50px;
        width: 50px;
        color: #4095e5;
        font-size: 20px;
      "
      @click="checkBoxdialog = true"
      v-if="checkBoxData.length > 0"
    >
      <!-- <i class="iconfont icon-icon-test" style="width:100%;height:100%;font-size: 40px;"></i> -->
      <el-badge :value="checkBoxNumber">
        <img
          src="../../../static/img/selects.png"
          style="width: 70%; height: 70%; font-size: 40px"
        />
        <!-- <span class="iconfont icon-icon-test" style="width:100%;height:100%;font-size: 40px;"></span> -->
      </el-badge>
    </div>
    <!-- 显示购物车列表 -->
    <el-dialog
      title="已选择设备"
      :visible.sync="checkBoxdialog"
      append-to-body
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-button
        type="primary"
        size="mini"
        @click="removeAllCheckbox"
        style="margin-top: -30px; float: left"
        >清空内容</el-button
      >
      <el-table
        :data="checkBoxData"
        v-if="checkBoxNumber > 0"
        :header-cell-style="{ background: '#eff3f6' }"
        style="padding-top: 5px"
      >
        <el-table-column type="selection" width="55" :reserve-selection="true">
        </el-table-column>
        <el-table-column
          :label="lable.index"
          type="index"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span>{{ scope.$index + (pageIndex - 1) * pagesize + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="id"
          sortable
          :label="lable.id"
          show-overflow-tooltip
        >
          <template slot-scope="scope" show-overflow-tooltip>
            <el-link
              :underline="false"
              @click="details(scope.row)"
              style="color: #4095e5; text-decoration: none"
            >
              {{ scope.row.id }}
            </el-link>
          </template>
        </el-table-column>
        <el-table-column
          prop="glbh"
          sortable
          :label="lable.glbh"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="jdsb"
          sortable
          :label="lable.jdsb"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="ssdw"
          sortable
          :label="lable.companyName"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          sortable
          prop="checkCertificate"
          :label="lable.checkCertificate"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          sortable
          prop="checkTime"
          :label="lable.checkTime"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="jg"
          sortable
          :label="lable.jg"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="nextCheckTime"
          sortable
          :label="lable.nextCheckTime"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="checkStatue"
          sortable
          :label="lable.statue"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span v-if="scope.row.checkStatue == 1" style="color: #4095e5"
              >待确认</span
            >
            <span v-else style="color: blueviolet">核查介绍</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" style="text-decoration: none">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="removeThisData(scope.row)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import {
  selectAllCheck,
  selectAllstatus,
  test,
  derivation,
  findByModule,
  deleteCheckId,
  findByUserIdCompanyTree
} from "../../api/api";

export default {
  name: "correctingVerification",
  data() {
    return {
      deviceInfo: {
        date: [],
        content: "",
        state: "",
      },
      lable: {},
      show: {
        lr: false,
        dcfj: false,
        zf: false,
      },
      checkBoxdialog: false,
      checkBoxData: [],
      checkBoxNumber: 0,
      total: 0,
      pageIndex: 1,
      pagesize: 10,
      options: [],
      checkData: [],
      companyTree:[],

      props: {
        checkStrictly: true,
        label: "companyName",
        value: "companyCode",
        children: "zcompany",
        emitPath: false,

      },
    };
  },
  methods: {
    //作废
    deleteCheck(row) {
      this.$confirm("确定删除该条信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        console.log(row);
        var userinfo = JSON.parse(localStorage.getItem("user"));
        var map = {
          id: row.id,
          userId: userinfo.userId,
        };
        deleteCheckId(map).then((datas) => {
          let { status, message } = datas;
          if (status == 400) {
            this.$message({
              message: message,
              type: "error",
            });
          } else if (status == 200) {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.findAll();
          } else {
            this.$message({
              message: "请求错误",
              type: "error",
            });
          }
        });
      });
    },
    getRowKeys(row) {
      return row.id;
    },
    //清空所有内容
    removeAllCheckbox() {
      this.checkBoxData = [];
      this.checkBoxNumber = this.checkBoxData.length;
      this.$refs.multipleTable.clearSelection(); //清除所有选中复选框
      this.checkBoxdialog = false;
    },
    //获取复选框选中数据
    changeCheckBoxValue(val) {
      console.log(val);
      this.checkBoxData = val;
      this.checkBoxNumber = this.checkBoxData.length;
    },
    //移除一条选中内容
    removeThisData(row) {
      let newCheckBoxData = [];
      for (var i = 0; i < this.checkBoxData.length; i++) {
        if (this.checkBoxData[i].id != row.id) {
          // debugger
          newCheckBoxData.push(this.checkBoxData[i]);
        }
      }
      this.checkBoxData = newCheckBoxData;
      if (this.checkBoxData.length > 0) {
        this.$refs.multipleTable.store.states.selection.map((item, index) => {
          if (item.id === row.id) {
            this.$refs.multipleTable.store.states.selection.splice(index, 1);
          }
        });
      } else {
        this.$refs.multipleTable.clearSelection(); //清除所有选中复选框
        this.checkBoxdialog = false;
      }
      this.checkBoxNumber = this.checkBoxData.length;
    },
    derive() {
      this.loadingUtil.showLoading("正在下载中，请稍后……");
      let _this = this;
      var userinfo = JSON.parse(localStorage.getItem("user"));
      let map = {
        start: this.deviceInfo.date == null ? null : this.deviceInfo.date[0],
        end: this.deviceInfo.date == null ? null : this.deviceInfo.date[1],
        content: this.deviceInfo.content,
        jdlx: 1,
        userId: userinfo.userId,
      };
      if (this.checkBoxData.length > 0) {
        map["ids"] = this.checkBoxData.map((item) => item.id).join();
      }else{
        map["ids"] = ""
      }
      derivation(map).then((datas) => {
        const blob = new Blob([datas]);
        // debugger
        const dlink = document.createElement("a");
        if ("download" in document.createElement("a")) {
          // 非IE下载
          const dlink = document.createElement("a");
          dlink.download = "试验检测仪器设备核查计划及完成表.doc";
          dlink.style.display = "none";
          dlink.href = URL.createObjectURL(blob);
          document.body.appendChild(dlink);
          dlink.click();
          URL.revokeObjectURL(dlink.href); // 释放URL 对象
          document.body.removeChild(dlink);
        } else {
          // IE10+下载
          navigator.msSaveBlob(blob, "试验检测仪器设备核查计划及完成表.doc");
        }
        _this.loadingUtil.hideLoading();
      });
      // window.open(getBase()+'/word/derivation')
    },
    handleCreate() {
      let val = {
        path: "/AddCorrecting",
        name: "核查录入",
      };
      this.$router.push({
        path: "AddCorrecting",
      });
      this.$store.commit("pushtags", val);
    },
    details(row) {
      let val = {
        path: "/correctingParticulars",
        name: "核查祥情",
      }; // debugger //保存数据
      sessionStorage.setItem("addCor", true);
      sessionStorage.setItem("id", row.id);
      sessionStorage.setItem("corVerIndex", this.pageIndex);
      sessionStorage.setItem("corVerData", JSON.stringify(this.deviceInfo));

      // sessionStorage.setItem("department", vals.department); //添加路由跳转至查看设备
      this.$router.push({
        path: "correctingParticulars",
      });
      this.$store.commit("pushtags", val);
    },
    findAll() {
      var userinfo = JSON.parse(localStorage.getItem("user"));
      if (sessionStorage.getItem("addCor") == "true") {
        if (sessionStorage.getItem("corVerIndex") != undefined) {
          this.pageIndex = sessionStorage.getItem("corVerIndex") * 1;
          if (sessionStorage.getItem("addCor") == "true") {
            sessionStorage.setItem("addCor", false);
            this.deviceInfo = JSON.parse(sessionStorage.getItem("corVerData"));
            sessionStorage.removeItem("corVerData");
          }
        }
      }
      let map = {
        start: this.deviceInfo.date == null ? null : this.deviceInfo.date[0],
        end: this.deviceInfo.date == null ? null : this.deviceInfo.date[1],
        content: this.deviceInfo.content,
        state: this.deviceInfo.state,
        jdlx: 1,
        userId: userinfo.userId,
        pageIndex: this.pageIndex,
        pageSize: this.pagesize,
        companyCode:this.deviceInfo.companyCode
      };
      selectAllCheck(map).then((datas) => {
        // debugger
        let { status, message, data } = datas;
        if (status == 200) {
          this.checkData = data.list;
          this.total = data.total;
        }
      });
    },
    findAllClick() {
      this.pageIndex = 1;
      this.findAll();
    },
    dcfj() {
      if (this.checkBoxData.length >= 1) {
        var map = { list: this.checkBoxData.map((item) => item.id) };
        test(map).then((datas) => {
          const blob = new Blob([datas]);
          // debugger
          const dlink = document.createElement("a");
          if ("download" in document.createElement("a")) {
            // 非IE下载
            const dlink = document.createElement("a");
            dlink.download = "核查附件.zip";
            dlink.style.display = "none";
            dlink.href = URL.createObjectURL(blob);
            document.body.appendChild(dlink);
            dlink.click();
            URL.revokeObjectURL(dlink.href); // 释放URL 对象
            document.body.removeChild(dlink);
          } else {
            // IE10+下载
            navigator.msSaveBlob(blob, "核查附件.zip");
          }
        });
      } else {
        this.$message.error("请选择核查记录"); // .....失败信息
      }
    },
    findAllType() {
      selectAllstatus().then((datas) => {
        // debugger
        let { status, message, data } = datas;
        if (status == 200) {
          for (var i = 0; i < data.length; i++) {
            if (data[i].statusType == "设备核查") {
              this.options.push({
                name: data[i].statusName,
                id: data[i].statue,
              });
            }
          }
        }
      });
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      sessionStorage.setItem("corVerIndex", val);
      //contentdata是所有的数据，是一个大数组。使用.slice()方法可以将大数组切分
      //.slice()方法接受两个参数，开始和结束的值
      //这样得到的currentdata就是固定只有10个值的数组了，就可以用v-for展示啦
      this.findAll();
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.findAll();
    },
    findLable() {
      findByModule("设备核查").then((datas) => {
        let { status, message, data } = datas;
        if (status == 200) {
          this.lable = data;
        }
      });
    },
    getCompanyTree() {
      var userinfo = JSON.parse(localStorage.getItem("user"));
      var  companyCode='';
      if (userinfo.userRole == 1 || (userinfo.fjqx != null && (userinfo.fjqx.indexOf ("3")!=-1||userinfo.fjqx.indexOf ("4")!=-1))) {
        companyCode="-1"
      }else{
        companyCode=userinfo.companyCode
      }
      findByUserIdCompanyTree(companyCode).then((datas) => {
        let { status, message, data } = datas;
        if (status == 200) {
          this.companyTree = this.getTreeData(data);
        }
      });
    },
    getTreeData(data) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].zcompany.length < 1) {
          // 最后一级没有数据将children变成undefined
          data[i].zcompany = undefined;
        } else {
          // children不为空时继续调用该方法
          this.getTreeData(data[i].zcompany);
        }
      }
      return data;
    },
  },
  created() {
    this.getCompanyTree();
    this.findLable();
    this.findAll();
    this.findAllType();
    var userinfo = JSON.parse(localStorage.getItem("user"));
    var arr = userinfo.role.menuId.split(",");
    arr.forEach((i) => {
      if (i == "98") {
        this.show.lr = true;
      }
      if (i == "99") {
        this.show.dcfj = true;
      }
      if (i == "198") {
        this.show.zf = true;
      }
    });
  },
  // keep-alive 缓存后重新激活时，保留搜索条件刷新列表
  activated() {
    this.findAll();
  },
};
</script>
<style >
.el-checkbox__inner {
  border: 1px solid #606266 !important;
}
</style>
<style scoped>
.btn {
  float: left;
  margin-left: 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/selfCorrecting/correctingVerification.vue